<template>
  <v-container fluid ma-0 v-if="item.videoSrc">
    <ArticleTipImage :height="height" :darkMode="darkMode" :item="item" />
    <nuxt-link :to="articleLink" class="black--text d-block" @click.stop="log">
      <div v-if="darkMode">
        <ArticleHighlight :highlight="highlight" :class="'round-bottom mb-1'" />
      </div>
      <ArticleTipDetails
        :item="item"
        :darkMode="darkMode"
        :breakFooter="breakFooter"
      />
    </nuxt-link>
  </v-container>
  <v-container fluid ma-0 v-else>
    <nuxt-link :to="articleLink" class="black--text d-block" @click.stop="log">
      <ArticleTipImage :height="height" :darkMode="darkMode" :item="item" />
      <div v-if="darkMode">
        <ArticleHighlight :highlight="highlight" :class="'round-bottom mb-1'" />
      </div>
      <ArticleTipDetails
        :item="item"
        :darkMode="darkMode"
        :breakFooter="breakFooter"
      />
    </nuxt-link>
  </v-container>
</template>
 
<script>
import ArticleTipImage from '@/components/Articles/ArticleTipImage';
import ArticleHighlight from '@/components/Articles/ArticleHighlight';
import ArticleTipDetails from '@/components/Articles/ArticleTipDetails';
import ArticleLinkVue from './mixins/ArticleLink.js';

export default {
  mixins: [ArticleLinkVue],
  components: {
    ArticleTipImage,
    ArticleHighlight,
    ArticleTipDetails,
  },
  props: {
    item: {
      type: Object,
      required: false,
    },
    height: {
      type: String,
      required: false,
      default: '161px',
    },
    darkMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    breakFooter: {
      type: Boolean,
      required: false,
      default: false,
    },
    highlight: {
      type: String,
      required: false,
      default: '',
    },
  },
  methods: {
    log(e) {
      e.stopPropagation();
      e.stopImmediatePropagation();
      e.preventDefault();
    },
    openVideo() {
      this.$nuxt.$emit('openVideo', this.item.videoSrc);
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
